export const THRESHOLD = 500;
export const ITEMS_PER_PAGE = 3;
